<template>
    <div>
        <div>
            <div>
                <el-row>
                    <div class="left-justifying"><h3>合同计费调整</h3></div>
                    <div class="right-justifying">
                        <el-button type="info" plain size="small" @click="toAdd" v-if="addBtnExisted">
                            <i class="fa fa-plus-circle">
                            </i> 新建
                        </el-button>
                        <el-button type="info" plain size="small" @click="saveAdd" v-if="saveAddBtnExisted">
                            <i class="fa fa-save">
                            </i> 保存
                        </el-button>
                        <el-button type="info" plain size="small" @click="toEdit" v-if="editBtnExisted" :disabled="$refs['detail'].form.model.id == null">
                            <i class="fa fa-pencil">
                            </i> 修改
                        </el-button>
                        <el-button type="info" plain size="small" @click="saveEdit" v-if="saveEditBtnExisted">
                            <i class="fa fa-save">
                            </i> 保存
                        </el-button>
                        <el-button type="info" plain size="small" @click="cancelEdit" v-if="cancelEditBtnExisted">
                            <i class="fa fa-undo">
                            </i> 取消
                        </el-button>
                        <!--<el-button type="info" plain size="small" @click="toRemove" v-if="deleteBtnExisted">
                            <i class="fa fa-times">
                            </i> 删除
                        </el-button>-->
                    </div>
                </el-row>
            </div>
            <div class="panel">
                <div class="panel-body">
                    <el-row>
                        <el-tabs v-model="activeTabName" :before-leave="beforeLeave">
                            <el-tab-pane label="列表" name="list">
                                <contract-bill-adjust-list ref="list" :search="list.search">
                                </contract-bill-adjust-list>
                            </el-tab-pane>
                            <el-tab-pane label="详情" name="detail">
                                <contract-bill-adjust-detail ref="detail" @operation-change="onOperationChange">
                                </contract-bill-adjust-detail>
                            </el-tab-pane>
                        </el-tabs>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        COMPONENT_MAIN,
        TAB_LIST, OPERATION_LIST_DEFAULT,
        TAB_DETAIL, OPERATION_DETAIL_SHOW, OPERATION_DETAIL_ADD, OPERATION_DETAIL_EDIT,
        FN_SET_TAB, FN_SET_OPERATION,
        FN_LIST_QUERY, FN_TO_DETAIL_SHOW,
        PERMISSION_ADD, PERMISSION_EDIT, PERMISSION_DELETE
    } from './contract.bill.adjust.common'
    import ContractBillAdjustList from './contract.bill.adjust.list'
    import ContractBillAdjustDetail from './contract.bill.adjust.detail'
    export default {
        name: COMPONENT_MAIN,
        componentName: COMPONENT_MAIN,
        provide() {
            return {
                toDetailShow: this.toShow,
                toDetailAdd: this.toAdd,
                toDetailEdit: this.toEdit,
                toDetailRemove: this.toRemove,
            };
        },
        components: {ContractBillAdjustList, ContractBillAdjustDetail},
        data() {
            return {
                activeTabName: TAB_LIST,
                operation: null,
                list: {
                    search: {},
                },
                detail: {
                    data: null,
                }
            };
        },
        computed: {
            addBtnExisted() {
                return this.activeTabName === TAB_LIST && (PERMISSION_ADD == null || this.hasPermission(PERMISSION_ADD));
            },
            saveAddBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_ADD &&
                    (PERMISSION_ADD == null || this.hasPermission(PERMISSION_ADD));
            },
            editBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_SHOW &&
                    (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
            },
            saveEditBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_EDIT &&
                    (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
            },
            cancelEditBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_EDIT &&
                    (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
            },
            deleteBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_SHOW &&
                    (PERMISSION_DELETE == null || this.hasPermission(PERMISSION_DELETE));
            },
        },
        methods: {
            setDefaultOperation(tabName) {
                if (this.operation == null || this.operation.split('.')[0] !== tabName) {
                    let operation;
                    if (tabName === TAB_LIST) {
                        operation = OPERATION_LIST_DEFAULT;
                        this[FN_LIST_QUERY]();
                    } else if (tabName === TAB_DETAIL) {
                        operation = OPERATION_DETAIL_SHOW;
                        this.detail.data = this.$refs['list'].currentRowData;
                    }
                    if (operation != null) {
                        this[FN_SET_OPERATION](operation);
                    }
                }
            },
            beforeLeave(tabName, oldTabName) {
                if (oldTabName === TAB_DETAIL && (this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT)) {
                    return this.$confirm('您输入的数据未保存，确认离开吗？', '离开提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.setDefaultOperation(tabName);
                        return Promise.resolve();
                    }, () => {
                        return Promise.reject();
                    });
                } else {
                    this.setDefaultOperation(tabName);
                }
                return Promise.resolve();
            },
            [FN_SET_TAB](tabName) {
                this.activeTabName = tabName;
            },
            [FN_SET_OPERATION](operation) {
                this.operation = operation;
            },
            [FN_TO_DETAIL_SHOW](data) {
                this[FN_SET_TAB](TAB_DETAIL);
                this[FN_SET_OPERATION](OPERATION_DETAIL_SHOW);
                this.detail.data = data;
            },
            [FN_LIST_QUERY]() {
                this.$refs['list'].query();
            },
            onOperationChange(operation) {
                this[FN_SET_OPERATION](operation);
            },
            getDetailComponent() {
                return this.$refs['detail'];
            },
            toShow(data) {
                this[FN_SET_TAB](TAB_DETAIL);
                this.getDetailComponent().toShow(data);
            },
            toAdd() {
                this[FN_SET_TAB](TAB_DETAIL);
                this[FN_SET_OPERATION](OPERATION_DETAIL_ADD);
                this.getDetailComponent().toAdd({});
            },
            saveAdd() {
                this.getDetailComponent().saveAdd();
            },
            toEdit(data) {
                this[FN_SET_TAB](TAB_DETAIL);
                this.getDetailComponent().toEdit(data);
            },
            saveEdit() {
                this.getDetailComponent().saveEdit();
            },
            cancelEdit() {
                this.getDetailComponent().cancelEdit();
            },
            toRemove(data) {
                this.getDetailComponent().toRemove(data);
            }
        },
        created() {
            this.$on(FN_SET_TAB, (data) => {
                this[FN_SET_TAB](data);
            });
            this.$on(FN_SET_OPERATION, (data) => {
                this[FN_SET_OPERATION](data);
            });
            this.$on(FN_TO_DETAIL_SHOW, (data) => {
                this[FN_TO_DETAIL_SHOW](data);
            });
            this.$on(FN_LIST_QUERY, () => {
                this[FN_LIST_QUERY]();
            });
        },
        mounted() {
            setTimeout(() => {
                this[FN_LIST_QUERY]();
            });
        }
    }
</script>

<style scoped>

</style>